<script lang="ts" setup>
import { ref, onMounted, nextTick } from 'vue';
const props = defineProps<{
    content: string
}>();

const content = ref('')
const contentLoaded = ref(false)

onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
    content.value = props.content;
      contentLoaded.value = true;
    }, 100)
  })
});
</script>
<template>
    <div class="container-fluid">
      <div class="container-xl">
        <div v-if="contentLoaded" v-html="content"></div>
      </div>
    </div>
</template>